import { Group, Text } from "@mantine/core";

export interface LiveIndicatorProps {
  /** Whether the thing being watched is currently live. */
  readonly live: boolean;
  /** Wording shown beside the dot when live. */
  readonly label?: string;
  /** Wording shown when it is not live. */
  readonly idleLabel?: string;
}

/**
 * The one live-state treatment: a restrained pulse plus the word itself, so the state never depends on color or motion
 * alone. The pulse is reserved for a genuinely live, connected, or updating state and stops under
 * `prefers-reduced-motion` (docs/UI_STANDARDS.md, motion).
 */
export function LiveIndicator({ live, label = "Live", idleLabel = "Idle" }: LiveIndicatorProps) {
  return (
    <Group gap={6} wrap="nowrap" align="center">
      {live ? (
        <span className="how-live-dot" aria-hidden />
      ) : (
        <span className="how-idle-dot" aria-hidden />
      )}
      <Text component="span" size="xs" fw={600} c={live ? "teal" : "dimmed"}>
        {live ? label : idleLabel}
      </Text>
    </Group>
  );
}
